module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/tours-icon-21a7f556d1d63bb5e4fc07cfc66bde4b.png";